// extracted by mini-css-extract-plugin
export default {"label":"styles_label__pO6N7","span":"styles_span__Bmtrc","input":"styles_input__e1Z3Z"};